var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayWhileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 35,
    viewBox: "0 0 29 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 30.2341V4.76789C0 2.66797 0 1.61684 0.38687 0.995529C0.724525 0.453256 1.24497 0.0972202 1.82276 0.0120988C2.48453 -0.0853948 3.29618 0.409054 4.91716 1.39655L25.8187 14.1296L25.8263 14.1335C27.6176 15.2248 28.5137 15.7707 28.8077 16.4983C29.0641 17.133 29.0641 17.8657 28.8077 18.5004C28.5133 19.229 27.6151 19.7772 25.8187 20.8715L4.91716 33.6046C3.29502 34.5928 2.48476 35.0854 1.82276 34.9879C1.24497 34.9027 0.724525 34.5468 0.38687 34.0045C0 33.3832 0 32.334 0 30.2341Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayWhileIcon);
export default __webpack_public_path__ + "static/media/play-while-icon.08913aea404a1320b144c71671527540.svg";
export { ForwardRef as ReactComponent };